import { z } from "zod";

import { WorkerCommissionExclusionReason } from "@/entities/worker";

export const addCommissionExclusionSchema = z.object({
  reason: z.nativeEnum(WorkerCommissionExclusionReason),
  comment: z.string(),
});

export type AddCommissionExclusionSchema = z.infer<
  typeof addCommissionExclusionSchema
>;
